<template>
  <v-container grid-list-xs>
    <v-layout row wrap align-center>
      <v-flex xs12 class="text-xs-center">
        <h1 class="display-1">Select Your #</h1>
        <p>Please select the phone number that you wish to use below.</p>
      </v-flex>
    </v-layout>
    <v-layout class="mt-5">
      <v-container grid-list-lg>
        <v-layout row wrap v-if="!phoneNumbers">
          <v-flex xs-12 md4 offset-md4 class="pa-3">
            <h2 class="headline text-xs-center">Loading available phone numbers...</h2>
            <v-progress-linear indeterminate height="2" color="primary lighten-1"></v-progress-linear>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-else>
          <v-flex xs12 md4>
            <v-select
              label="Select a Province"
              @change="provinceChanged"
              v-model="province"
              :items="provinces"
              :rules="[rules.required]"
              item-text="name"
              item-val="value"
              cache-items
              required
              bottom
            ></v-select>
            <span style="display: none;">
              {{ province }}
            </span>
          </v-flex>   
          <v-flex xs12 md4>
            <v-select
              label="Select a City"
              @change="cityChanged"
              v-model="city"
              :items="cities"
              :rules="[rules.required]"
              item-text="name"
              item-value="value"
              :disabled="!province"
              required
              bottom
            ></v-select>          
          </v-flex>  
          <v-flex xs12 md4>
            <v-select
              label="Select an Area Code"
              v-model="areaCode"
              :items="areaCodes"
              :rules="[rules.required]"
              :disabled="!province"
              required
              bottom
            ></v-select>
          </v-flex>  
        </v-layout>
        <v-layout row wrap v-if="numbers.length > 0">
          <v-flex xs12 class="text-xs-left">
            <div class="subheading">Select a Phone Number:</div>
            <v-radio-group v-model="phoneNumber">
              <v-list class="phone-list">
                <v-list-tile v-for="(number, index) in numbers" :key="`num-${index}`">
                  <v-list-tile-content>
                    <v-radio :label="number | phone" :value="number"></v-radio>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-radio-group>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="mb-3">
          <v-flex xs6 class="text-xs-left">
            <v-btn
              @click="goBack"
              class="ml-0"
              outline
              color="secondary"
            >&laquo; Back</v-btn>
          </v-flex>
          <v-flex xs6 class="text-xs-right">
            <v-btn 
              @click="submit" 
              class="mr-0"
              outline
              color="primary"
              :disabled="!phoneNumber"
            >Next &raquo;</v-btn>
          </v-flex>
        </v-layout>
      </v-container>  
    </v-layout>    
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      valid: false,
      country: "CA", // default country
      province: null,
      city: null,
      areaCode: null,
      phoneNumber: null,
      cities: [],
      areaCodes: [],
      availableNumbers: [],
      numbers: [],
      provinceMap: {
        AB: "Alberta",
        BC: "British Columbia",
        MB: "Manitoba",
        NB: "New Brunswick",
        NL: "Newfoundland & Labrador",
        NS: "Nova Scotia",
        NT: "Northwest Territories",
        NU: "Nunavut",
        ON: "Ontario",
        PE: "Prince Edward Island",
        QC: "Quebec",
        SK: "Saskatchewan",
        YT: "Yukon"
      },
      rules: {
        required: value => {
          return value !== undefined || "Required";
        }
      }
    };
  },
  created() {
    this.$store.dispatch("getPhoneNumbers");
    // populate drop downs if values are in the store
    this.province = this.$store.getters.selectedPhone
      ? this.$store.getters.selectedPhone.province
      : null;
    this.city = this.$store.getters.selectedPhone ? this.$store.getters.selectedPhone.city : null;
    this.areaCode = this.$store.getters.selectedPhone
      ? this.$store.getters.selectedPhone.areaCode
      : null;
    this.phoneNumber = this.$store.getters.selectedPhone
      ? this.$store.getters.selectedPhone.phoneNumber
      : null;
  },
  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    submit() {
      this.$store.dispatch("setSelectedPhone", {
        province: this.province,
        city: this.city,
        areaCode: this.areaCode,
        phoneNumber: this.phoneNumber
      });
      this.$router.push({ name: "billing-details" });
    },
    provinceChanged() {
      this.city = null;
      this.areaCode = null;
      this.phoneNumber = null;
    },
    cityChanged() {
      this.areaCode = null;
      this.phoneNumber = null;
    },
    formattedNumber(numberObj) {
      return `(${numberObj.areaCode}) ${numberObj.exchangeCode}-${numberObj.lineNumber}`;
    }
  },
  watch: {
    province(newValue, oldValue) {
      if (newValue != null) {
        let cityList = [];
        Object.keys(this.phoneNumbers[this.country][newValue]).forEach(function(city) {
          cityList.push({
            name: city.toLowerCase().replace(/^(.)|\s(.)/g, $1 => $1.toUpperCase()),
            value: city
          });
        });
        this.cities = cityList;
      }
    },
    city(newValue, oldValue) {
      if (newValue != null && newValue !== oldValue) {
        let areacodeList = [];
        Object.keys(this.phoneNumbers[this.country][this.province][newValue]).forEach(function(
          areaCode
        ) {
          areacodeList.push(areaCode);
        });
        this.areaCodes = areacodeList;
      }
    },
    areaCode(newValue, oldValue) {
      if (newValue != null && newValue !== oldValue) {
        this.numbers = this.phoneNumbers[this.country][this.province][this.city][newValue];
      }
    }
  },
  computed: {
    phoneNumbers() {
      return this.$store.getters.phoneNumbers;
    },
    provinces() {
      let provinceList = [];
      let provinces = Object.keys((this.phoneNumbers && this.phoneNumbers[this.country]) || {});
      provinces.forEach(function(provinceCode) {
        provinceList.push({ name: this.provinceMap[provinceCode], value: provinceCode });
      }, this);
      return provinceList;
    }
  }
};
</script>

<style scoped>
.phone-list {
  border: 5px solid #eee;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/activation/PhoneNumberSelection.vue